import type { InvariantRoute } from '@atlassian/react-resource-router/src/common/types.tsx';

export const legacyGinActionRoute: InvariantRoute = {
	name: 'legacy-gin-action',
	path: '/secure/IssueNavAction!default.jspa',
	query: ['filter|jql|issueKey'],
};
